export default __webpack_public_path__ + "static/media/B_wdt_c_cap_2.a48054f7.mp3";